// import store from '@/store'
import { initializeApp } from 'firebase/app'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { 
  getAuth, 
  signInWithEmailAndPassword, 
  signOut, 
  createUserWithEmailAndPassword,
  sendEmailVerification
} from 'firebase/auth'
import { 
  getFunctions, 
  httpsCallable, 
  connectFunctionsEmulator 
} from 'firebase/functions'
import store from "@/store";


const config = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
   };
   
export default {
  install: (Vue) => {
    Vue.prototype.$appName = process.env.VUE_APP_NAME
    Vue.prototype.$appUrl = process.env.VUE_APP_URL
    const app = initializeApp(config)
    const db = getFirestore(app)
    const auth = getAuth(app)
    let functions = getFunctions(app, 'europe-west3')
    if(process.env.NODE_ENV === 'development'){
      // Use the current hostname so the app also works when accessed
      // from other devices on the LAN (e.g. Zebra scanners)
      const emulatorHost = window.location.hostname
      connectFunctionsEmulator(functions, emulatorHost, 5002)
      connectFirestoreEmulator(db, emulatorHost, 8070)
    }
    // Minimal wrapper to keep existing usage: this.$functions.httpsCallable('name')
    Vue.prototype.$functions = {
      httpsCallable: (name, options) => httpsCallable(functions, name, options)
    }
    
    // auth.onAuthStateChanged((user) => {
    //   // console.log('auth', user);
    //   if(!auth) return
    //   store.dispatch('user/get_user', user)
    // })
    
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        const user = await signInWithEmailAndPassword(auth, username, pass)
        return user
      },
      logout: async () => {
        store.dispatch('app/reset_state')
        await signOut(auth)
      },
      signup: async (email, password) => {
        const user = await createUserWithEmailAndPassword(auth, email, password)
        if(auth.currentUser) await sendEmailVerification(auth.currentUser)
        // const id = auth.currentUser.uid
        // await store.dispatch('user/get_user', { id, email, name })
        return user
      }
    }
  },
}
